import React from 'react';
import { Switch, Route } from 'react-router-dom';

import ForgotPassword from '../components/pages/ForgotPassword';
import ForgotPasswordError from '../components/pages/ForgotPasswordError';
import GoToBackLogin from '../components/pages/GoToBackLogin';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route
        component={GoToBackLogin}
        path={`/redefinicao-senha/voltar`}
        exact
      />
      <Route component={ForgotPassword} path="/:id" exact />
      <Route component={ForgotPasswordError} path="/" exact />
    </Switch>
  );
};

export default Routes;
